import {AvatarComponentProps} from '@dropbox/dig-components/avatar';
import {Text, TextProps} from '@dropbox/dig-components/typography';
import {Box, withShade} from '@dropbox/dig-foundations';
import {EmployeeLdap} from 'client';
import {LabelGroup} from 'components/DSYS/LabelGroup';

import {Avatar} from './Avatar';
import {PersonHoverCard} from './HoverCard';
import {Link} from './Link';

export const EmployeeButton = ({
  employee,
  avatarSize = 'small',
  display,
  to,
  ...props
}: TextProps & {
  employee: EmployeeLdap;
  avatarSize?: AvatarComponentProps['size'];
  display?: 'inline-block' | 'block';
  // Where it links, in the same tab; their profile in a new tab without one.
  to?: string;
}) => (
  <PersonHoverCard ldap={employee.ldap} name={employee.name}>
    <Box
      borderRadius="Medium"
      paddingX="8"
      paddingY="4"
      display={display}
      {...withShade({style: {marginLeft: -8, marginRight: -8}})}
    >
      <Link to={to ?? `/people/${employee.ldap}`} hasNoUnderline openInNewTab={!to}>
        <LabelGroup
          withLeftAccessory={<Avatar size={avatarSize} user={employee} />}
          withText={<Text {...props}>{employee.name}</Text>}
        />
      </Link>
    </Box>
  </PersonHoverCard>
);
